<template>
    <div class="min-h-screen bg-white flex items-center justify-center p-4">
        <div class="max-w-md w-full text-center">
            
            <!-- 404 Number -->
            <div class="mb-8">
                <h1 class="text-[10rem] font-light text-gray-200 leading-none tracking-tight">
                    404
                </h1>
            </div>

            <!-- Message -->
            <h2 class="text-2xl font-medium text-gray-900 mb-3">
                Page introuvable
            </h2>
            
            <p class="text-gray-500 mb-12 leading-relaxed">
                La page que vous recherchez n'existe pas.
            </p>

            <!-- Actions -->
            <div class="space-y-3">
                <button 
                    @click="goHome"
                    class="w-full px-6 py-3 bg-gray-900 text-white font-medium rounded-lg hover:bg-gray-800 transition-colors">
                    Retour à l'accueil
                </button>
                
                <button 
                    @click="goBack"
                    class="w-full px-6 py-3 text-gray-600 font-medium hover:text-gray-900 transition-colors">
                    Page précédente
                </button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFound',
    methods: {
        goHome() {
            window.location.href = '/';
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1);
            } else {
                this.goHome();
            }
        }
    }
}
</script>
